import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";
import {PreviousMeetingsWidgetController} from "../previous-meetings-widget.controller";

export class PreviousMeetingsWidgetProps extends BaseModuleProps {
  controller: PreviousMeetingsWidgetController;
  isFullView: Boolean;
  shouldFilterByHomeAway: Boolean;
}
